var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToolsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.835 15L16.835 20C17.663 20.828 19.007 20.828 19.835 20V20C20.663 19.172 20.663 17.828 19.835 17L14.835 12",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.916 5.84718C20.94 5.87018 20.958 5.90018 20.967 5.93218C21.437 7.49918 21.073 9.26218 19.835 10.5002C18.584 11.7512 16.797 12.1092 15.218 11.6172L6.87099 19.9642C6.05799 20.7772 4.73199 20.8382 3.89099 20.0542C3.00699 19.2312 2.98899 17.8472 3.83499 17.0002L12.218 8.61718C11.726 7.03818 12.084 5.25118 13.335 4.00018C14.573 2.76218 16.336 2.39818 17.903 2.86818C17.935 2.87818 17.965 2.89518 17.988 2.91918L18.15 3.08118C18.228 3.15918 18.228 3.28618 18.15 3.36418L15.515 6.00018L17.835 8.32018L20.471 5.68418C20.549 5.60618 20.676 5.60618 20.754 5.68418L20.916 5.84718V5.84718Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.933 4.29296L3.607 6.31596C3.743 6.72496 4.125 6.99996 4.556 6.99996H6.835V4.72096C6.835 4.29096 6.56 3.90796 6.151 3.77196L4.128 3.09796C3.948 3.03796 3.75 3.08496 3.616 3.21896L3.054 3.78096C2.92 3.91496 2.873 4.11296 2.933 4.29296V4.29296Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84 7L10.34 10.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsIcon);
export default __webpack_public_path__ + "static/media/ToolsIcon.b97a4c5f4cb0e00ca31bc2a996f04d29.svg";
export { ForwardRef as ReactComponent };